import { render, staticRenderFns } from "./solicitorServices.vue?vue&type=template&id=132c13b4"
import script from "./solicitorServices.vue?vue&type=script&lang=js"
export * from "./solicitorServices.vue?vue&type=script&lang=js"
import style0 from "./solicitorServices.vue?vue&type=style&index=0&id=132c13b4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports